import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import InstallPWA from './components/InstallPWA';
import ErrorBoundary from './components/ErrorBoundary';
import Landing from './pages/Landing';
import Studio from './pages/Studio';
import Battle from './pages/Battle';
import Live from './pages/Live';
import Fans from './pages/Fans';
import Shop from './pages/Shop';
import Settings from './pages/Settings';
import AdminDiagnostics from './pages/AdminDiagnostics';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  useEffect(() => {
    document.title = 'MUZI BATTLE — Chante, Joue, Deviens viral';
  }, []);

  return (
    <div className="App" translate="no">
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <Navbar />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/battle" element={<Battle />} />
              <Route path="/live" element={<Live />} />
              <Route path="/fans" element={<Fans />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admin/diagnostics" element={<AdminDiagnostics />} />
            </Routes>
            <Footer />
            <AuthModal />
            <InstallPWA />
            <Toaster position="top-right" theme="dark" richColors />
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
